export const staticMetaProps = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/magazine/`,
  seoTitle: 'ЦИАН - Новости, статьи и аналитика рынка недвижимости в Москве и России',
  seoDescription: 'ЦИАН - новости, статьи, аналитика и другая информация о рынке недвижимости в Москве и России',
  seoKeywords: 'новости, статьи, журнал, недвижимость, информация',
});
